import dio, { DioType, DioContext } from 'app/utils/dio/init';
import { omit } from 'lodash';

const SENSITIVE_FIELDS = ['password'];

export default {
  firstPageView() {
    dio.track(
      'registration_page_first_view',
      DioType.PAGEVIEW,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  firstPageFillData(email) {
    dio.updateIdentity({ email });
    dio.track(
      'registration_page_first_fill_data',
      DioType.CLICK,
      { email },
      DioContext.REGISTRATION_V2
    );
  },
  firstPageClickSignUpGoogle() {
    dio.track(
      'registration_page_google_sign_up_click',
      DioType.CLICK,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  firstPageSignUpGoogleCompleted(email) {
    dio.updateIdentity({ email });
    dio.track(
      'registration_page_google_sign_up_completed',
      DioType.PAGEVIEW,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  formPageView(signUpGoogle) {
    dio.track(
      'registration_page_form_view',
      DioType.PAGEVIEW,
      { signUpGoogle },
      DioContext.REGISTRATION_V2
    );
  },
  formPageFillData(formValues) {
    dio.track(
      'registration_page_form_fill_data',
      DioType.CLICK,
      omit(formValues, SENSITIVE_FIELDS),
      DioContext.REGISTRATION_V2
    );
  },
  formPageApproveTerms() {
    dio.track(
      'registration_page_form_terms_approved',
      DioType.CLICK,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  formPageClickNext(signUpGoogle) {
    dio.track(
      'registration_page_form_click_next',
      DioType.CLICK,
      { signUpGoogle },
      DioContext.REGISTRATION_V2
    );
  },
  verifyPageView() {
    dio.storeAuthData(); // Save identity to use it on the activation page

    dio.track(
      'registration_page_verify_view',
      DioType.PAGEVIEW,
      {},
      DioContext.REGISTRATION_V2
    );
  },
  completePageView(signUpGoogle) {
    dio.track(
      'registration_page_complete_view',
      DioType.PAGEVIEW,
      { signUpGoogle },
      DioContext.REGISTRATION_V2
    );
  },
  completePageClickLogin(signUpGoogle) {
    dio.track(
      'registration_page_complete_click_login',
      DioType.CLICK,
      { signUpGoogle },
      DioContext.REGISTRATION_V2
    );
  },
};
